import React from 'react';

import ClickableIcon from '~components/ClickableIcon';
import { faCopy } from '~components/icon';
import { Row } from '~components/table-view';

interface ComponentProps {
  row?: Row;
  onCopy?: (id: string) => void;
}

const PricePlanActions: React.FC<ComponentProps> = ({ row, onCopy }) => (
  <ClickableIcon
    id={`price-plan-copy-${row?.id}`}
    icon={faCopy}
    onClick={() => row?.id && onCopy?.(String(row.id))}
    toolTip="Copy plan"
    ariaLabel="Copy plan"
    dataCy={`sah-price-plan-copy-icon-${row?.id ?? 'unknown'}`}
  />
);

export default PricePlanActions;
